import React from "react"
import PropTypes from "prop-types"
import "./button.scss"

const Button = (props) => {
  let {
    text,
    classes = [],
    action,
    type,
    fullWidth,
    style,
    id,
    download,
    disabled,
    className = " ",
  } = props

  const buttonAction = (e) => {
    e.preventDefault()
    action(e)
  }

  const styles = () => {
    if (fullWidth) {
      return {
        width: fullWidth ? "100%" : "auto",
        ...style,
      }
    }
    return style
  }

  if (download) {
    return (
      <a
        data-cy={props["data-cy"]}
        id={id}
        onClick={action}
        href={disabled ? undefined : download}
        className={`btn ${classes && classes.join(" ")} ${
          disabled && "disabled"
        }`}
        style={styles()}
        download
      >
        {props.children}
        {text}
      </a>
    )
  }

  return (
    <button
      id={id}
      type={type ? type : "button"}
      style={styles()}
      onClick={buttonAction}
      disabled={disabled}
      className={`btn ${classes && classes.join(" ")} ${className}`}
      data-cy={props["data-cy"]}
    >
      {props.children}
      {text}
    </button>
  )
}

Button.propTypes = {
  classes: PropTypes.arrayOf(PropTypes.string),
  fullWidth: PropTypes.bool,
  action: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  style: PropTypes.object,
  id: PropTypes.string,
  download: PropTypes.string,
}

export default Button
